module.exports = __webpack_public_path__ + "media/images/icon_search_green-beade129b4f7e2fd9e713a6df1f0c383.svg";